import { HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ToastrService } from 'ngx-toastr';
import { WhatsappTemplateService } from 'src/app/private/services/whatsapp-tempate.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

export interface CarouselCard {
  id: number;
  mediaId: string;
  mediaUrl?: string;
  mediaData: string;          // base64 data URL for instant local preview
  fileName: string;
  uploadProgress: number;     // 0 to 100%
  isProcessingMedia: boolean;
  body: string;               // Card description text (<= 160 characters)
  buttons: Array<{
    type: 'URL' | 'QUICK_REPLY';
    text: string;             // Button title (e.g. "Shop Now")
    url?: string;             // Required if type is 'URL'
  }>;
}

@Component({
  selector: 'app-creatae-whatsapp-template',
  templateUrl: './creatae-whatsapp-template.component.html',
  styleUrls: ['./creatae-whatsapp-template.component.scss']
})
export class CreataeWhatsappTemplateComponent implements OnInit, OnDestroy {
  public Editor = ClassicEditor as unknown as any;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();

  @Input() type: string = 'Create';
  @Input() templateDataToEdit: any;
uploadProgress: number = 0;
isProcessingMedia = false;
loadingSampleGif = false;
readonly sampleGifMp4Path = 'assets/img/sample-whatsapp-gif-template.mp4';

  carouselCards: CarouselCard[] = [
    { id: 1, mediaId: '', mediaData: '', fileName: '', uploadProgress: 0, isProcessingMedia: false, body: '', buttons: [] },
    { id: 2, mediaId: '', mediaData: '', fileName: '', uploadProgress: 0, isProcessingMedia: false, body: '', buttons: [] }
  ];
  previewCarouselIndex = 0;
  expandedCarouselCard = 0;

  btnLoading = false;
  template: any = {
    template_name: '',
    header_text: '',
    category: '',
    language: '',
    labels: '',
    header: 'none',
    body: '',
    footer: '',
    media: '',
    mediaData: ''
  };
  languages: string[] = ['English', 'Hindi', 'Gujarati'];
  isSubmitted = false;
  editorData = '';
  currentTime!: string;
  public variableCounter: number = 0;
  private timerId: any;

  countQuickReplyButton: number = 0;
  countCTAButtonForURL: number = 0;
  countCTAButtonForCall: number = 0;

  quickReplyButtons: any[] = [];
  urlButtons: any[] = [];
  callButtons: any[] = [];
  languagesList: any[] = [];

  appId: any;
  appName: string = '';
  token: any;

  variables: { [key: string]: string } = {}; // Object to hold variables and their sample values
  variableNames: { [key: string]: string } = {}; // Object to hold variables and their sample values
  renderedData: any = '';
variableNameError: boolean = false; 
  showAllVariables = false;
  fileName: string = '';
  fileType: string = '';
  base64Data: string = '';
  initiaBody: boolean = false;
  templateData: any;

  templateIDToEdit: any;
  mediaId: string = '';
  suffix: string = '';
  showMediaThroughMediaID: boolean = false;
  variableError: boolean = false;
  public editorConfig = {
    toolbar: ['bold', 'italic', 'bulletedList', 'numberedList', 'horizontalLine']
  };
  allowedFields: string[] = [
    'name', 'email', 'phone', 'company_name', 'order_id',
    'reference_no', 'followup_date', 'appointment_date',
    'appointment_time', 'followup_time', 'ticket_id',
    'date', 'time','lead_id',
  ];
  constructor(
    private toastr: ToastrService,
    private api: WhatsappTemplateService,
    private localStorage: LocalStorageService,

  ) { }

  isMobile = false;
  openPreview = false;
  togglePreview(){
    this.openPreview = !this.openPreview;
    if (this.openPreview) {
      setTimeout(() => {
        const el = document.querySelector('.right-side-box');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth < 992;
  }

  ngOnInit() {
    this.isMobile = window.innerWidth < 992;
    this.updateTime();
    this.timerId = setInterval(() => this.updateTime(), 60000); // Update every minute
    this.getAllLanguages();
    this.storeAppId();

    setTimeout(() => {
      if (this.type === 'Edit') {
        this.templateData = this.templateDataToEdit;
        this.templateDataToEdit = this.templateDataToEdit.template_data;


        const { header, body, footer } = this.splitString(this.templateDataToEdit.containerMeta);

        const { quickReplyButtons, urlButtons, callButtons } = this.parseButtons(this.templateDataToEdit.containerMeta);

        this.quickReplyButtons = quickReplyButtons.map((button: string) => ({ value: button }));

        this.urlButtons = urlButtons.map((button: any) => ({ title: button.text, urlType: button.urlType, value: button.url, suffix: button.suffix }));

        this.callButtons = callButtons.map((button: any) => ({ title: button.text, value: button.url }));

        this.countQuickReplyButton = this.quickReplyButtons.length;

        this.countCTAButtonForURL = this.urlButtons.length;

        this.countCTAButtonForCall = this.callButtons.length;




        this.template = {
          template_name: this.templateDataToEdit.elementName,
          header_text: header,
          category: this.templateDataToEdit.category,
          labels: this.templateDataToEdit.vertical,
          body: body,
          footer: footer,
          header: (header === '' || header === undefined) ? 'none' : 'text',
          language: this.templateDataToEdit.languageCode,
        };
        this.template.category = (this.template.category || '').toUpperCase();


        this.templateIDToEdit = this.templateDataToEdit.id;

        this.editorData = this.formateData(this.template.body);;
        this.initiaBody = true;
        this.renderedData = this.formateData(this.editorData);

        const metaData = JSON.parse(this.templateDataToEdit.containerMeta);

        // Populate variableNames if exists
        let incomingVars = null;
        if (this.templateDataToEdit.variables) {
             incomingVars = this.templateDataToEdit.variables;
        } else if (this.templateData && this.templateData.variables) {
             incomingVars = this.templateData.variables;
        }

        if (incomingVars) {
           console.log('Found variables in edit data:', incomingVars);
           this.variableNames = typeof incomingVars === 'string' 
             ? JSON.parse(incomingVars) 
             : incomingVars;
        } else {
             console.log('No variables found in edit data', this.templateDataToEdit, this.templateData);
        }

        if (this.templateDataToEdit.templateType === 'IMAGE' || this.templateDataToEdit.templateType === 'VIDEO' || this.templateDataToEdit.templateType === 'DOCUMENT' || this.templateDataToEdit.templateType === 'GIF') {

          this.template.header = 'media';
          this.template.media = this.mapTemplateTypeToMedia(this.templateDataToEdit.templateType);
          const data = JSON.parse(this.templateDataToEdit.meta);
          this.mediaId = data.mediaId;
          this.showMediaThroughMediaID = true;
        } else if (this.templateDataToEdit.templateType === 'CAROUSEL') {
          this.template.header = 'carousel';
          const incomingCards = this.templateDataToEdit.cards || this.templateData?.template_data?.cards || [];
          if (incomingCards && incomingCards.length > 0) {
            this.carouselCards = incomingCards.map((c: any, idx: number) => ({
              id: idx + 1,
              mediaId: c.mediaId || '',
              mediaUrl: c.mediaUrl || '',
              mediaData: c.mediaUrl || '',
              fileName: c.fileName || `Card ${idx + 1}`,
              uploadProgress: c.mediaId ? 100 : 0,
              isProcessingMedia: false,
              body: c.body || '',
              buttons: (c.buttons || []).map((b: any) => ({
                type: b.type || 'URL',
                text: b.text || '',
                url: b.url || ''
              }))
            }));
          }
        }

        if (metaData.sampleText) {

          const variablePattern = /\{\{\d+\}\}/g;
          const variablesInText = this.editorData.match(variablePattern);

          if (variablesInText) {
            const uniqueVariables = new Set(variablesInText);
            const variablesArray = Array.from(uniqueVariables);

            if (uniqueVariables.size < this.variableCounter) {
              let start = 1;

              // Loop through and replace all variables sequentially
              variablesArray.forEach((variable) => {
                const escapedVariable = variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special chars
                const variablePattern = new RegExp(escapedVariable, 'g');
                this.editorData = this.editorData.replace(variablePattern, `{{${start}}}`);
                start++;
              });

              // Update the variable counter
              this.variableCounter = start - 1;
            } else {
              this.variableCounter = uniqueVariables.size;
            }
          }

          this.extractVariables();

          this.variables = this.extractAndPopulate(metaData.sampleText);
          this.renderedData = this.removeBrackets(metaData.sampleText);
        }
      }
    }, 1000);
  }

  extractAndPopulate(inputString: string): { [key: string]: string } {
    const matches = inputString.match(/\[([^\]]+)\]/g);
    const result: { [key: string]: string } = {};

    if (matches) {
      matches.forEach((match, index) => {
        result[`{{${index + 1}}}`] = match.replace(/[\[\]]/g, '');  // Remove brackets and assign
      });
    }

    return result;
  }

  removeBrackets(input: string): string {
    let output = input.replace(/\*(.*?)\*/g, '<b>$1</b>');

    // Step 2: Remove square brackets [] but keep the content inside
    output = output.replace(/\[(.*?)\]/g, '$1');

    return output;
  }

  formateData(data: any) {
    return data
      .replace(/\n/g, '<br>') // Replace \n with <br>
      .replace(/\*(.*?)\*/g, '<b>$1</b>'); // Replace *text* with <b>text</b>
  }
    formatForApi(text: string): string {
      if (!text) return '';

      return text
        .replace(/<br\s*\/?>/gi, '\n') // safety
        .replace(/&amp;/g, '&')
        .replace(/\r/g, '')
        .trim();
    }
  splitString(inputString: any) {

    const inputData = JSON.parse(inputString);

    const { header, data: body, footer } = inputData;

    return {
      header: header,
      body: body,
      footer: footer
    };
  }

  parseButtons(input: string): {
    quickReplyButtons: string[], urlButtons: { text: string, urlType: string, url: string }[],
    callButtons: { text: string, url: string }[]
  } {
    const quickReplyButtons: string[] = [];
    const urlButtons: {
      text: string, urlType: string, url: string,
      suffix?: string
    }[] = [];
    const callButtons: { text: string, url: string }[] = [];

    // Parse the input string as JSON
    const inputData = JSON.parse(input);

    // Assuming buttons field is present in the input JSON
    const { buttons } = inputData;


    if (buttons) {
      buttons.forEach((button: any) => {
        if (button.type === 'QUICK_REPLY') {
          // Add to quickReplyButtons if type is QUICK_REPLY
          quickReplyButtons.push(button.text.trim());
        } else if (button.type === 'URL') {
          // Add to urlButtons if type is URL

          if (button.url.includes('{{1}}')) {
            const url = button.url.split('{{1}}');
            const suffix = button.example[0].split("/")[3];
            urlButtons.push({ text: button.text.trim(), urlType: "dynamic", url: url[0].trim(), suffix: suffix });
          } else {
            urlButtons.push({ text: button.text.trim(), urlType: "static", url: button.url.trim() });
          }
        } else if (button.type === 'PHONE_NUMBER') {
          // Add to urlButtons if type is URL
          callButtons.push({ text: button.text, url: button.phone_number });
        }
      });
    }

    return { quickReplyButtons, urlButtons, callButtons };
  }



  getAllLanguages() {
    this.api.getAllLanguages().subscribe((res: any) => {
      this.languagesList = res;
    });
  }

  storeAppId() {
    const payload = {
      client_id: this.localStorage.getClientId()
    };
    this.api.getAppId(payload).subscribe((res: any) => {
      this.appId = res.app_id;
      this.token = res.app_token;
      this.appName = res.app_name || '';
    });
  }


  ngOnDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }

  updateTime() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    this.currentTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  onCategoryChange() {
    if (this.template.category === 'UTILITY' && this.template.header === 'carousel') {
      this.template.header = 'none';
    }
  }

  onSubmit() {
    console.log('variableNames:', this.variableNames);
    this.isSubmitted = true;

    if (this.isValidForm()) {
      this.btnLoading = true;
      let modifyButtons: any = [];

      this.quickReplyButtons.forEach((button: any) => {
        modifyButtons.push({
          type: 'QUICK_REPLY',
          text: button.value
        });
      });

      this.urlButtons.forEach((button: any) => {


        if (button.urlType === 'static') {
          modifyButtons.push({
            type: 'URL',
            text: button.title,
            url: button.value
          });
        } else if (button.urlType === 'dynamic') {


          // {"type":"URL","text":"visit us","url":"https://gravitas.ai/{{1}}","example":["https://gravitas.ai/about"]}

          modifyButtons.push({
            type: 'URL',
            text: button.title,
            url: button.value + '{{1}}',
            example: [button.value + button.suffix]
          });
        }

      });

      this.callButtons.forEach((button: any) => {
        modifyButtons.push({
          type: 'PHONE_NUMBER',
          text: button.title,
          phone_number: button.value
        });
      });

      let exampleData = this.editorData;


      for (const variable in this.variables) {
        const value = this.variables[variable] || ''; // Use empty string if no value is provided

        const escapedVariable = variable.replace(/[{}]/g, '\\$&'); // Escape the curly braces
        const regex = new RegExp(escapedVariable, 'g'); // Create a global regular expression
        exampleData = this.renderedData.replace(regex, `[${value}]`);
      }



      const isCarousel = this.template.header === 'carousel';
      let templateType = 'TEXT';
      if (isCarousel) {
        templateType = 'CAROUSEL';
        if (!this.carouselCards || this.carouselCards.length < 2) {
          this.toastr.error('Carousel template requires at least 2 cards.');
          this.btnLoading = false;
          return;
        }
        for (let i = 0; i < this.carouselCards.length; i++) {
          const card = this.carouselCards[i];
          if (!card.mediaId) {
            this.toastr.error(`Card ${i + 1} is missing an image. Please upload an image.`);
            this.btnLoading = false;
            return;
          }
          if (!card.body || !card.body.trim()) {
            this.toastr.error(`Card ${i + 1} text is required.`);
            this.btnLoading = false;
            return;
          }
          if (!card.buttons || card.buttons.length < 1) {
            this.toastr.error(`Card ${i + 1} must have at least 1 button. (WhatsApp Carousel cards require at least 1 button each).`);
            this.btnLoading = false;
            return;
          }
          for (let b = 0; b < card.buttons.length; b++) {
            const btn = card.buttons[b];
            if (!btn.text || !btn.text.trim()) {
              this.toastr.error(`Button ${b + 1} on Card ${i + 1} requires text.`);
              this.btnLoading = false;
              return;
            }
            if (btn.type === 'URL' && (!btn.url || !btn.url.trim())) {
              this.toastr.error(`URL button "${btn.text}" on Card ${i + 1} requires a valid URL.`);
              this.btnLoading = false;
              return;
            }
          }
        }
        const firstCardBtnCount = this.carouselCards[0].buttons.length;
        for (let i = 1; i < this.carouselCards.length; i++) {
          if (this.carouselCards[i].buttons.length !== firstCardBtnCount) {
            this.toastr.error(`All cards in a carousel must have the same number of buttons. Card 1 has ${firstCardBtnCount}, but Card ${i + 1} has ${this.carouselCards[i].buttons.length}.`);
            this.btnLoading = false;
            return;
          }
        }
      } else if (this.template.header === 'media') {
        templateType = this.mapMediaToTemplateType(this.template.media);
      }

      const payload: any = {
        client_id: this.localStorage.getClientId(),
        user_id: this.localStorage.getUserId(),
        elementName: this.template.template_name,
        languageCode: this.template.language,
        category: this.template.category,
        template_id: this.templateIDToEdit,
        templateType: templateType,
        vertical: this.template.labels,
        content: this.convertHtmlToText(this.editorData),
        header: this.template.header === 'text' ? this.template.header_text : '',
        exampleHeader: this.template.header_text,
        footer: this.template.footer,
        example: this.generateSample(this.editorData),
        enableSample: this.template.header === 'media' || isCarousel,
        allowTemplateCategoryChange: false,
        buttons: isCarousel ? [] : modifyButtons,
        mediaId: isCarousel ? '' : (this.template.header === 'media' ? this.mediaId : ''),
        variables: this.variableNames,
      };

      if (isCarousel) {
        payload.cards = this.carouselCards.map(c => ({
          mediaId: c.mediaId,
          mediaUrl: c.mediaUrl || '',
          body: c.body,
          sampleText: c.body,
          buttons: (c.buttons || []).map(b => ({
            type: b.type,
            text: b.text,
            url: b.type === 'URL' ? b.url : undefined
          }))
        }));
      }

      console.log('Payload to be sent:', payload);

      if (this.type === 'Edit') {



        this.api.updateTemplate(payload).subscribe({
          next: (res: any) => {
            this.formSubmit.emit();
          },
          error: (err: any) => {
            this.btnLoading = false;
            this.toastr.error('Failed to create template.', 'Error');
          },
          complete: () => {
            console.log('Template creation process completed.');
          }
        });
      } else {
        this.api.createTemplate(payload).subscribe({
          next: (res: any) => {
            this.formSubmit.emit();
          },
          error: (err: any) => {
            console.error('Error creating template:', err);
            this.btnLoading = false;
            this.toastr.error(err?.error || 'Failed to create template.', 'Error');
          },
          complete: () => {
            console.log('Template creation process completed.');
          }
        });
      }



      // Handle form submission, e.g., send data to the server
    } else {
      console.error('Form submission failed. Please correct the errors.');
    }
  }


  convertHtmlToText(html: string): string {
      if (!html) return '';

      let text = html;

      // Convert paragraphs to double newlines
      text = text.replace(/<p[^>]*>/gi, '');
      text = text.replace(/<\/p>/gi, '\n\n');

      // Convert <br> to single newline
      text = text.replace(/<br\s*\/?>/gi, '\n');

      // Convert bold
      text = text.replace(/<strong>(.*?)<\/strong>/gi, '*$1*');
      text = text.replace(/<b>(.*?)<\/b>/gi, '*$1*');

      // Decode HTML entities
      text = text.replace(/&nbsp;/gi, ' ');
      text = text.replace(/&amp;/gi, '&');
      text = text.replace(/&lt;/gi, '<');
      text = text.replace(/&gt;/gi, '>');

      // Normalize spacing
      text = text.replace(/\n{3,}/g, '\n\n');

      return text.trim();
}


  generateSample(html: string): string {
  if (!html) return '';

  let text = html;

  // Convert paragraphs to double newlines
  text = text.replace(/<p[^>]*>/gi, '');
  text = text.replace(/<\/p>/gi, '\n\n');

  // Convert line breaks
  text = text.replace(/<br\s*\/?>/gi, '\n');

  // Convert bold tags to WhatsApp bold
  text = text.replace(/<strong>(.*?)<\/strong>/gi, '*$1*');
  text = text.replace(/<b>(.*?)<\/b>/gi, '*$1*');

  // Decode HTML entities
  text = text.replace(/&nbsp;/gi, ' ');
  text = text.replace(/&amp;/gi, '&');
  text = text.replace(/&lt;/gi, '<');
  text = text.replace(/&gt;/gi, '>');

  // Normalize spacing
  text = text.replace(/\n{3,}/g, '\n\n').trim();

  // Replace variables with sample values
  return text.replace(/{{\d+}}/g, match => {
    return `[${this.variables?.[match] || match}]`;
  });
}

  isValidForm(): boolean {
    // Template names can only contain small letters, numbers and underscores.
    const templateNameValid = this.template.template_name !== '' &&
      /^[a-z0-9_]+$/.test(this.template.template_name);
    const categoryValid = this.template.category !== '';
    const languageValid = this.template.language !== '';
    const labelsValid = this.template.labels !== '';
    const headerValid = this.template.header !== '';
    const bodyValid = this.editorData !== '';

    const header_textValid = this.template.header === 'text' ? this.template.header_text !== '' : true;
    const mediaIdValid = this.template.header === 'media' ? this.mediaId !== '' : true;

    // checking for any variable empty or not 

    for (const variable in this.variables) {
      if (this.variables[variable] === '') {
        this.variableError = true;
        return false;
      }
    }


    // checking for value in on quick reply button

    if (this.quickReplyButtons.length > 0) {
      for (let i = 0; i < this.quickReplyButtons.length; i++) {
        if (this.quickReplyButtons[i].value === '') {
          this.toastr.error('Please enter value in quick reply button.', 'Error');
          return false;
        }
      }
    }

    // checking for value in on url button

    if (this.urlButtons.length > 0) {
      for (let i = 0; i < this.urlButtons.length; i++) {
        if (this.urlButtons[i].value === '' || this.urlButtons[i].title === '' || this.urlButtons[i].urlType === '') {
          this.toastr.error('Please enter value in url button.', 'Error');
          return false;
        }

        if (this.urlButtons[i].urlType === 'dynamic' && this.urlButtons[i].suffix === '') {
          this.toastr.error('Please enter suffix in url button.', 'Error');
          return false;
        }

        // check for value must be url
        if (this.urlButtons[i].urlType === 'static' && !this.urlButtons[i].value.includes('http')) {
          this.toastr.error('Please enter valid url in url button.', 'Error');
          return false;
        }

        if (this.urlButtons[i].urlType === 'dynamic' && !this.urlButtons[i].value.includes('http')) {
          this.toastr.error('Please enter valid url in url button.', 'Error');
          return false;
        }
      }
    }

    // checking for value in on call button

    if (this.callButtons.length > 0) {
      for (let i = 0; i < this.callButtons.length; i++) {
        if (this.callButtons[i].value === '' || this.callButtons[i].title === '') {
          this.toastr.error('Please enter value in call button.', 'Error');
          return false;
        }
      }
    }

    if (this.template.header === 'carousel') {
      if (!this.carouselCards || this.carouselCards.length < 2) {
        this.toastr.error('Carousel requires at least 2 cards.', 'Validation Error');
        return false;
      }
      if (this.carouselCards.length > 10) {
        this.toastr.error('Carousel allows a maximum of 10 cards.', 'Validation Error');
        return false;
      }
      const firstCardButtons = this.carouselCards[0].buttons?.length || 0;
      for (let i = 0; i < this.carouselCards.length; i++) {
        const card = this.carouselCards[i];
        if ((card.buttons?.length || 0) !== firstCardButtons) {
          this.toastr.error(`All cards must have the same number of buttons. Card 1 has ${firstCardButtons}, but Card ${i + 1} has ${card.buttons?.length || 0}.`, 'Validation Error');
          return false;
        }
        if (!card.mediaId) {
          this.toastr.error(`Card ${i + 1} requires an uploaded image.`, 'Validation Error');
          return false;
        }
        if (!card.body || card.body.trim() === '') {
          this.toastr.error(`Card ${i + 1} description is required.`, 'Validation Error');
          return false;
        }
        if (card.body.length > 160) {
          this.toastr.error(`Card ${i + 1} description exceeds 160 characters.`, 'Validation Error');
          return false;
        }
        if (card.buttons && card.buttons.length > 0) {
          for (let b = 0; b < card.buttons.length; b++) {
            const btn = card.buttons[b];
            if (!btn.text || btn.text.trim() === '') {
              this.toastr.error(`Button ${b + 1} on Card ${i + 1} requires a title.`, 'Validation Error');
              return false;
            }
            if (btn.type === 'URL' && (!btn.url || !btn.url.includes('http'))) {
              this.toastr.error(`URL button "${btn.text}" on Card ${i + 1} requires a valid URL (http/https).`, 'Validation Error');
              return false;
            }
          }
        }
      }
    }

    return templateNameValid && categoryValid && languageValid &&
      labelsValid && headerValid && bodyValid && header_textValid && mediaIdValid;
  }


  onFileChange(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    const acceptedFileTypes = this.acceptedFileTypes();
    if (!acceptedFileTypes.includes(file.type)) {
      this.toastr.error('Invalid file type. Please select a valid file type.', 'Error');
      return;
    }

    const maxSize = this.maxFileSize();
    if (maxSize && file.size > maxSize) {
      this.toastr.error('File size exceeds the maximum allowed size.', 'Error');
      return;
    }

    this.uploadMediaFile(file);
  }

  useSampleGif(): void {
    if (this.loadingSampleGif || this.btnLoading) {
      return;
    }

    if (this.template.media !== 'gif') {
      this.selectMedia('gif');
    }

    this.loadingSampleGif = true;

    fetch(this.sampleGifMp4Path)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Sample MP4 not found');
        }
        return response.blob();
      })
      .then((blob) => {
        const file = new File([blob], 'sample-whatsapp-gif-template.mp4', { type: 'video/mp4' });
        this.uploadMediaFile(file);
        this.toastr.success('Sample MP4 loaded. Uploading to Gupshup…', 'Success');
      })
      .catch((error) => {
        console.error(error);
        this.toastr.error('Could not load sample MP4.', 'Error');
      })
      .finally(() => {
        this.loadingSampleGif = false;
      });
  }

  uploadMediaFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.template.mediaData = e.target.result;
      this.fileName = file.name;
      this.showMediaThroughMediaID = false;
    };
    reader.readAsDataURL(file);

    const clientId = this.localStorage.getClientId();
    this.uploadProgress = 0;
    this.isProcessingMedia = false;

    this.api.uploadFile(file, clientId).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round((event.loaded / event.total) * 100);

          if (this.uploadProgress === 100) {
            this.isProcessingMedia = true;
            this.uploadProgress = 99;
          }
        }

        if (event.type === HttpEventType.Response) {
          if (typeof event.body === 'string') {
            this.uploadProgress = 0;
            this.isProcessingMedia = false;
            this.template.mediaData = '';
            this.fileName = '';
            const message = event.body.includes('whatsappConfig not present')
              ? 'WhatsApp is not configured for this client. Please add WhatsApp config in client settings.'
              : event.body;
            this.toastr.error(message, 'Upload failed');
            return;
          }

          const mediaId = this.extractMediaIdFromUploadResponse(event.body);

          if (mediaId) {
            this.mediaId = mediaId;
            this.isProcessingMedia = false;
            this.uploadProgress = 100;
            this.toastr.success('Media uploaded successfully', 'Success');
            return;
          }

          this.uploadProgress = 0;
          this.isProcessingMedia = false;
          this.template.mediaData = '';
          this.fileName = '';
          const message = event.body?.message || event.body?.error?.message || 'Upload completed but no media ID was returned from Gupshup';
          this.toastr.error(message, 'Upload failed');
        }
      },
      (error) => {
        this.uploadProgress = 0;
        this.isProcessingMedia = false;
        this.template.mediaData = '';
        this.fileName = '';
        const message = error?.error?.message || error?.message || 'Upload failed';
        this.toastr.error(message, 'Error');
        console.error(error);
      }
    );
  }

  extractMediaIdFromUploadResponse(body: any): string {
    if (!body) {
      return '';
    }

    if (typeof body === 'string') {
      if (body.includes('whatsappConfig not present')) {
        return '';
      }
      try {
        return this.extractMediaIdFromUploadResponse(JSON.parse(body));
      } catch {
        return '';
      }
    }

    if (body.message && !body.mediaId && !body.handleId) {
      return '';
    }

    if (body.mediaId) {
      return String(body.mediaId);
    }

    if (typeof body.handleId === 'string') {
      return body.handleId;
    }

    if (body.handleId?.message) {
      return String(body.handleId.message);
    }

    if (body.body) {
      return this.extractMediaIdFromUploadResponse(body.body);
    }

    return '';
  }



  removeMedia() {
    this.showMediaThroughMediaID = false;
    this.template.mediaData = '';
    this.mediaId = '';
    this.fileName = '';
  }

  closeModal() {
    this.close.emit();
  }


  maxFileSize(): number {
    switch (this.template.media) {
      case 'image':
        return 2 * 1024 * 1024; // 2 MB in bytes
      case 'gif':
        return 5 * 1024 * 1024; // 5 MB in bytes
      case 'video':
        return 20 * 1024 * 1024; // 20 MB in bytes
      case 'document':
        return 2 * 1024 * 1024; // 2 MB in bytes
      default:
        return 0;
    }
  }

  acceptedFileTypes(): string[] {
    switch (this.template.media) {
      case 'image':
        return ['image/jpeg', 'image/png'];
      case 'gif':
        return ['video/mp4'];
      case 'video':
        return ['video/mp4'];
      case 'document':
        return ['application/pdf'];
      default:
        return [];
    }
  }

  mapMediaToTemplateType(media: string): string {
    const map: Record<string, string> = {
      image: 'IMAGE',
      video: 'VIDEO',
      document: 'DOCUMENT',
      gif: 'GIF',
      location: 'LOCATION'
    };
    return map[media] || 'LOCATION';
  }

  mapTemplateTypeToMedia(templateType: string): string {
    const map: Record<string, string> = {
      IMAGE: 'image',
      VIDEO: 'video',
      DOCUMENT: 'document',
      GIF: 'gif'
    };
    return map[templateType] || '';
  }

  isMediaWithUpload(): boolean {
    return ['image', 'video', 'document', 'gif'].includes(this.template.media);
  }


  selectMedia(mediaType: string) {
    this.template.media = mediaType;
    this.base64Data = '';
    this.template.mediaData = '';
  }

  addVariable(event: any): void {
    event.preventDefault();
    this.variableCounter++;
    const newVariable = `{{${this.variableCounter}}}`;

    // Remove trailing whitespace, including newlines, from the editor data
    this.editorData = this.editorData.trimEnd();

    // Find the last occurrence of a closing </p> tag
    const closingPTagsIndex = this.editorData.lastIndexOf('</p>');

    // If a closing </p> tag is found, insert the variable before it
    if (closingPTagsIndex !== -1) {
      this.editorData =
        this.editorData.slice(0, closingPTagsIndex) +
        newVariable +
        this.editorData.slice(closingPTagsIndex);
    } else {
      // If no </p> tag is found, just append the variable at the end of the data
      this.editorData += newVariable;
    }


    this.extractVariables();
  }


  onEditorChange(): void {

    this.initiaBody = false;
    if (this.editorData.length == 0) {
      this.variableCounter = 0;
      this.extractVariables();
      return;
    }

    const variablePattern = /\{\{\d+\}\}/g;
    const variablesInText = this.editorData.match(variablePattern);

    if (variablesInText) {
      const uniqueVariables = new Set(variablesInText);
      const variablesArray = Array.from(uniqueVariables);

      if (uniqueVariables.size < this.variableCounter) {
        let start = 1;

        // Loop through and replace all variables sequentially
        variablesArray.forEach((variable) => {
          const escapedVariable = variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special chars
          const variablePattern = new RegExp(escapedVariable, 'g');
          this.editorData = this.editorData.replace(variablePattern, `{{${start}}}`);
          start++;
        });

        // Update the variable counter
        this.variableCounter = start - 1;
      } else {
        this.variableCounter = uniqueVariables.size;
      }
    }

    this.extractVariables();
  }
deleteVariable(key: string) {
  // Remove from variables list
  delete this.variables[key];
  delete this.variableNames[key];

  // Remove from editor content
  const escapedKey = key.replace(/[{}]/g, '\\$&');
  const regex = new RegExp(escapedKey, 'g');
  this.editorData = this.editorData.replace(regex, '');

  // Refresh variable list
  this.extractVariables();

  // Update preview
  this.updateRenderedData();

  // ✅ Update variableCounter from editor text
  const variablePattern = /\{\{\d+\}\}/g;
  const vars = this.editorData.match(variablePattern);
  this.variableCounter = vars ? vars.length : 0;
}

  extractVariables(): void {
    const variablePattern = /\{\{\d+\}\}/g;
    const variablesInText = this.editorData.match(variablePattern);
    const uniqueVariables = new Set(variablesInText);

    // have to trim extra vratibles key which is not in uniqueVariables
    for (const variable in this.variables) {
      if (!uniqueVariables.has(variable)) {
        delete this.variables[variable];
        delete this.variableNames[variable];
      }
    }
    // ✅ Initialize missing variables safely
    uniqueVariables.forEach(variable => {
      if (this.variables[variable] === undefined) {
        this.variables[variable] = '';
      }

      if (this.variableNames[variable] === undefined) {
        this.variableNames[variable] = '';
      }
    });


    this.updateRenderedData();


  }

  // Update the rendered data when the sample value is changed
  updateRenderedData(): void {
    this.renderedData = this.editorData;
    for (const variable in this.variables) {
      const value = this.variables[variable] || ''; // Use empty string if no value is provided

      const escapedVariable = variable.replace(/[{}]/g, '\\$&'); // Escape the curly braces
      const regex = new RegExp(escapedVariable, 'g'); // Create a global regular expression
      this.renderedData = this.renderedData.replace(regex, value);
    }

    for (const variable in this.variables) {
      if (this.variables[variable] === '') {
        this.variableError = true;
        return;
      }
    }

    for (const variableName in this.variableNames) {
      if (this.variableNames[variableName] === '') {
        this.variableNameError = true;
        return;
      }
    }

    this.variableError = false;
    this.variableNameError = false;
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }


  addQuickReplyButton(event: any): void {
    event.preventDefault();

    if (this.countQuickReplyButton + this.countCTAButtonForCall + this.countCTAButtonForURL > 10) {
      this.toastr.error('You can add maximum 10 buttons in a template.', 'Error');
      return
    }

    this.countQuickReplyButton++;

    this.quickReplyButtons.push({
      value: ''
    });

  }

  addUrlButton(event: any): void {

    if (this.countCTAButtonForURL > 1) {
      this.toastr.error('You can add maximum 2 Url Buttons in template', 'Error');
      return
    }

    event.preventDefault();
    this.countCTAButtonForURL++;
    this.urlButtons.push({
      value: '',
      title: '',
      urlType: '',
      suffix: '',
    });

  }

  addCallButton(event: any): void {
    event.preventDefault();


    if (this.countCTAButtonForCall > 0) {
      this.toastr.error('You can add maximum 1 CTA button in a template.', 'Error');
      return
    }

    this.countCTAButtonForCall++;
    this.callButtons.push({
      value: ''
    });
  }

  removeQuickReplyButton(event: any, index: any): void {
    event.preventDefault();
    this.countQuickReplyButton--;

    // remover perticular index from array
    this.quickReplyButtons.splice(index, 1);

  }

  removeUrlButton(event: any, index: any): void {
    event.preventDefault();
    this.countCTAButtonForURL--;
    this.urlButtons.splice(index, 1);
  }

  removeCallButton(event: any, index: any): void {
    event.preventDefault();
    this.countCTAButtonForCall--;
    this.callButtons.splice(index, 1);
  }

  showAllOptions() {
    this.showAllVariables = !this.showAllVariables;
  }

  // --- CAROUSEL METHODS ---

  addCarouselCard(): void {
    if (this.carouselCards.length >= 10) {
      this.toastr.warning('Maximum 10 cards allowed in a carousel.');
      return;
    }
    this.carouselCards.push({
      id: this.carouselCards.length + 1,
      mediaId: '',
      mediaData: '',
      fileName: '',
      uploadProgress: 0,
      isProcessingMedia: false,
      body: '',
      buttons: []
    });
    this.expandedCarouselCard = this.carouselCards.length - 1;
  }

  toggleCarouselCard(index: number): void {
    this.expandedCarouselCard = this.expandedCarouselCard === index ? -1 : index;
  }

  removeCarouselCard(index: number): void {
    if (this.carouselCards.length <= 2) {
      this.toastr.warning('A minimum of 2 cards is required.');
      return;
    }
    this.carouselCards.splice(index, 1);
    if (this.previewCarouselIndex >= this.carouselCards.length) {
      this.previewCarouselIndex = Math.max(0, this.carouselCards.length - 1);
    }
    if (this.expandedCarouselCard >= this.carouselCards.length) {
      this.expandedCarouselCard = this.carouselCards.length - 1;
    }
  }

  moveCarouselCard(index: number, direction: 'left' | 'right'): void {
    const targetIndex = direction === 'left' ? index - 1 : index + 1;
    if (targetIndex < 0 || targetIndex >= this.carouselCards.length) return;
    const temp = this.carouselCards[index];
    this.carouselCards[index] = this.carouselCards[targetIndex];
    this.carouselCards[targetIndex] = temp;
  }

  onCarouselCardFileChange(event: any, cardIndex: number): void {
    const file: File = event.target.files[0];
    if (!file) return;

    if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
      this.toastr.error('Please upload a JPEG or PNG image.', 'Invalid File');
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      this.toastr.error('Image size must be less than 2 MB.', 'File Too Large');
      return;
    }

    const card = this.carouselCards[cardIndex];
    const reader = new FileReader();
    reader.onload = (e: any) => {
      card.mediaData = e.target.result;
      card.fileName = file.name;
    };
    reader.readAsDataURL(file);

    card.uploadProgress = 0;
    card.isProcessingMedia = false;

    const clientId = this.localStorage.getClientId();
    this.api.uploadFile(file, clientId).subscribe({
      next: (ev: any) => {
        if (ev.type === HttpEventType.UploadProgress) {
          card.uploadProgress = Math.round((ev.loaded / ev.total) * 100);
          if (card.uploadProgress === 100) card.isProcessingMedia = true;
        }
        if (ev.type === HttpEventType.Response) {
          const resBody = ev.body;
          const mediaId = this.extractMediaIdFromUploadResponse(resBody);
          const extractedUrl = resBody?.mediaUrl || resBody?.url || resBody?.data?.mediaUrl || resBody?.data?.url || '';
          if (mediaId) {
            card.mediaId = mediaId;
            card.mediaUrl = extractedUrl;
            card.isProcessingMedia = false;
            card.uploadProgress = 100;
            this.toastr.success(`Card ${cardIndex + 1} image uploaded successfully.`);
          } else {
            card.uploadProgress = 0;
            card.isProcessingMedia = false;
            const msg = resBody?.message || 'Upload completed but no media ID was returned';
            this.toastr.error(msg, 'Upload Failed');
          }
        }
      },
      error: (err: any) => {
        card.uploadProgress = 0;
        card.isProcessingMedia = false;
        this.toastr.error(`Upload failed for Card ${cardIndex + 1}.`, 'Error');
      }
    });
  }

  addCarouselCardButton(cardIndex: number): void {
    const card = this.carouselCards[cardIndex];
    if (card.buttons.length >= 2) {
      this.toastr.warning('Maximum 2 buttons allowed per card.');
      return;
    }
    card.buttons.push({ type: 'URL', text: '', url: '' });
  }

  removeCarouselCardButton(cardIndex: number, buttonIndex: number): void {
    this.carouselCards[cardIndex]?.buttons.splice(buttonIndex, 1);
  }

  scrollCarouselPreview(direction: 'left' | 'right'): void {
    if (direction === 'left' && this.previewCarouselIndex > 0) {
      this.previewCarouselIndex--;
    } else if (direction === 'right' && this.previewCarouselIndex < this.carouselCards.length - 1) {
      this.previewCarouselIndex++;
    }
    const track = document.querySelector('.wa-carousel-cards-track');
    if (track) {
      const scrollAmount = 252;
      track.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    }
  }

  onCarouselTrackScroll(event: any): void {
    const element = event.target;
    const scrollLeft = element.scrollLeft;
    const cardWidth = 252;
    this.previewCarouselIndex = Math.round(scrollLeft / cardWidth);
  }

}
